import React, { useState, useEffect } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import Button from '@material-ui/core/Button';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import ITNext from "assets/img/ITNext.jpg";
import ITNextBanner from "assets/img/itnext-banner.jpg";


import styles from "assets/jss/material-kit-react/views/ITNext.js";
import { string } from "prop-types";

const useStyles = makeStyles(styles);

export default function MPMMainPage(props) {
    const classes = useStyles();

    const { ...rest } = props;
    const imageClasses = classNames(
        classes.imgRaised,
        classes.imgRoundedCircle,
        classes.imgFluid
    );

    return (
        <div>
            <Header
                color="transparent"
                brand="Material Kit React"
                rightLinks={<HeaderLinks />}
                fixed
                changeColorOnScroll={{
                    height: 200,
                    color: "white"
                }}
                {...rest}
            />
            <Parallax small filter image={require("assets/img/bg20.jpg")} />
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div>
                    <div className={classes.container}>

                        <GridContainer justify="center" className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.topdev}>
                                    <div>
                                        <img src={ITNext} alt="..." className={imageClasses} />
                                    </div>
                                    <div className={classes.name}>
                                        <h3 className={classes.title}>رویداد تجربه محور نگاهی به آینده فناوری اطلاعات (ITNext)</h3>
                                        <div className={classes.description}>
                                            <p>
                                                جشنواره ITNext رویدادی است که در آن افراد سر شناس در حوزه فناوری اطلاعات تجربیات و داستان موفقیت و شکست های خود را در قالب سخنرانی های کوتاه برای مخاطبین مطرح می کنند.
                                            </p>
                                            <p>
                                                معمولا این سخنرانی ها در برگیرنده تجربیات ویژه و خاص، یا دست آوردهای ارزشمند از شکست ها و موفقیت های افراد و شرکت هاست.
                                            </p>
                                            <p>
                                                هدف اصلی از برگزاری جشنواره فناوری اطلاعات ایران، انتقال تجربه بزرگان این حوزه، ارائه دلایل موفقیت و شکست افراد سرشناس در این حوزه، ایجاد انگیزه برای راه اندازی کسب کار های نوین و خلاقانه، بررسی چالش های پیش روی استارتاپ ها موفق و نوپا و نیز نشان دادن راه موفقیت های شغلی به دانشجویان گرامی می باشد.
                                            </p>
                                            <p>
                                                در این رویداد افراد سرشناس، نوآوران و پیشوایان اندیشه و عمل در حوزه فناوری اطلاعات گردهم می آیند تا ایده‌ها، تجربیات و ماجراهای خود را در قالب سخنرانی های کوتاه با مخاطبان به اشتراک بگذارند.
                                            </p>
                                        </div>
                                       <div classNames={classes.center} style={{marginTop:"50px"}}>
                                                 <Button variant="contained"  color="secondary" target='_blank' href="https://evand.com/events/%D8%AF%D9%88%D8%B1%D9%87%D9%85%DB%8C-%D8%AA%D8%AC%D8%B1%D8%A8%D9%87-%D9%85%D8%AD%D9%88%D8%B1-itnext-88761014" disableElevation>
                                                     جهت ثبت نام در ITNext 2025 اینجا کلیک کنید.
                                                 </Button>
                                             </div>
                                        
                                    </div>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h3>شرکت کنندگان</h3>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                    <p>جشنواره ITNext به‌عنوان یک رویداد جامع و چندجانبه، فضایی را برای حضور افرادی با زمینه‌های مختلف فراهم می‌آورد.</p>
                                    <p>شرکت کنندگان این رویداد از طیف های مختلف حوزه فناوری اطلاعات و ارتباطات شامل گروه های زیر هستند:</p>
                                    <p>
                                        <ul className={classes.rightToLeft}>
                                            <li><strong>نوآوران و کارآفرینان:</strong> افرادی که به دنبال معرفی ایده‌های نوآورانه خود هستند و می‌خواهند با دیگران در این زمینه تبادل نظر کنند.</li>
                                            <li><strong>اساتید و پژوهشگران:</strong> افرادی که در حوزه فناوری اطلاعات و علوم مرتبط فعالیت می‌کنند و می‌خواهند به اشتراک‌گذاری دانش و تجربیات خود بپردازند.</li>
                                            <li><strong>دانشجویان و فارغ‌التحصیلان:</strong> جوانانی که به دنبال ارتقاء مهارت‌های خود و ارتباط با حرفه‌ای‌ها در صنعت هستند و می‌خواهند از فرصت‌های شغلی و آموزشی بهره‌مند شوند.</li>
                                            <li><strong>طراحان و توسعه‌دهندگان:</strong> افرادی که در زمینه طراحی و توسعه نرم‌افزار و فناوری‌های نوین فعالیت می‌کنند و به دنبال الهام‌گیری و یادگیری از دیگران هستند.</li>
                                            <li><strong>سرمایه‌گذاران و مشاوران:</strong> افرادی که به دنبال شناسایی پروژه‌های نوآورانه و سرمایه‌گذاری در ایده‌های جدید هستند.</li>
                                            <li><strong>علاقه‌مندان به فناوری و نوآوری:</strong> افرادی که به‌طور عمومی به فناوری، نوآوری و آینده‌نگری در این حوزه علاقه‌مند هستند و می‌خواهند از نزدیک با روندها و چالش‌های این صنعت آشنا شوند.</li>
                                        </ul>
                                    </p>
                                    <p>این تنوع در شرکت‌کنندگان باعث می‌شود که جشنواره به یک بستر غنی برای تبادل ایده‌ها، یادگیری و همکاری تبدیل شود و به همه افراد حاضر این امکان را می‌دهد که از تجربیات یکدیگر بهره‌مند شوند.</p>
                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <div style={{textAlign: "center"}}>
                                <img src={ITNextBanner} style={{maxWidth:"700px", width:"100%", margin:"auto"}}/>
                                </div>
                            </GridItem>
                        </GridContainer>

                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h3>ماموریت و اهداف</h3>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                <p>ماموریت جشنواره ITNext ایجاد فضایی پویا و الهام‌بخش برای گردهمایی، گفت‌وگو و هم‌افزایی میان نوآوران، نخبگان و صاحبان ایده است. این جشنواره به‌دنبال ارتقاء همکاری‌ها و ایجاد ارتباطات مؤثر می‌باشد.</p>
                                    <br />
    <strong>اهداف کلیدی جشنواره</strong>
    <p>
    <ul>
        <li><strong>روایت ایده‌ها:</strong> تقویت انگیزه، خودباوری و اعتماد به نفس در جامعه، با هدف الهام‌بخشی به نسل‌های آینده و تشویق به خلاقیت.</li>
        <li><strong>ایجاد بستر ارتباطی:</strong> فراهم آوردن فضای مناسب برای تبادل نظر و گفت‌وگو میان نوآوران، اساتید و دانشجویان، به‌منظور تبادل تجربیات و ایده‌های نو.</li>
        <li><strong>پرورش ایده‌های نو:</strong> ایجاد بستری برای خلق و توسعه ایده‌های نو و بکر از طریق برنامه‌ها و کارگاه‌های متنوع.</li>
        <li><strong>الهام‌بخشی:</strong> گردآوری نوآوران، طراحان و جستجوگران در سطح کشور برای ایجاد فضایی الهام‌بخش و تشویق به نوآوری.</li>
        <li><strong>مشارکت فعال:</strong> تشویق به ارتباط، مباحثه و مشارکت میان شرکت‌کنندگان، به‌منظور ایجاد شبکه‌های مؤثر و خلاق.</li>
    </ul>
    </p>
    <br />
    <strong>مزایای جشنواره برای دانشجویان</strong>
    <p>این جشنواره به‌ویژه برای دانشجویان مزایای قابل توجهی دارد. شرکت‌کنندگان می‌توانند از طریق ارتباط با نخبگان و اساتید، شبکه‌سازی کنند و فرصت‌های شغلی و همکاری‌های تحقیقاتی را کشف کنند. همچنین، دسترسی به کارگاه‌ها و سخنرانی‌ها به آن‌ها کمک می‌کند تا با آخرین روندها و تکنولوژی‌های روز دنیا آشنا شوند و مهارت‌های عملی خود را تقویت کنند.</p>
    <p>تجربه‌های یادگیری چندجانبه و تعامل با افراد از زمینه‌های مختلف، دانشجویان را در مسیر خلاقیت و نوآوری یاری می‌کند و به آن‌ها انگیزه می‌دهد تا ایده‌های خود را پیگیری کنند. در نهایت، جشنواره فرصتی را برای معرفی ایده‌های نو به سرمایه‌گذاران فراهم می‌آورد که می‌تواند به حمایت‌های مالی و معنوی منجر شود.</p>
    <p>این جشنواره با هدف ایجاد یک بستر مناسب برای رشد و شکوفایی ایده‌ها و نوآوری‌ها در عرصه فناوری اطلاعات، به دنبال ارتقاء سطح علمی و فرهنگی جامعه است و به‌ویژه برای جوانان و دانشجویان فرصتی ارزشمند برای پیشرفت و توسعه فراهم می‌آورد.</p>

                                </div>
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h3>زمانبندی برگزاری</h3>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                    <p>
                                    در راستای برگزاری هر رویداد موفق، زمانبندی دقیق و منظم از اهمیت ویژه‌ای برخوردار است. جدول زیر شامل فعالیت‌های کلیدی و تاریخ‌های مربوط به هر یک از آن‌ها است. این زمانبندی به ما کمک می‌کند تا تمامی مراحل را به‌طور مؤثر مدیریت کرده و از پیشرفت مناسب رویداد اطمینان حاصل کنیم. 
                                    </p>
                                    <p color="orange">این تاریخ ها ممکن است بنا به شرایط تغییر کنند.</p>
                                    <p style={{ textAlign: "center", marginTop:"30px" }}>
                                        
    <table style={{ 
        border: "solid 1px #eee", 
        margin: "auto", 
        width: "100%", 
        maxWidth: "500px", 
        textAlign: "center"
    }}>
        <thead >
            <tr >
                <th style={{ 
        backgroundColor: "#eee"}}>عنوان</th>
                <th style={{ 
        backgroundColor: "#eee"}}>تاریخ</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>تدارکات برگزاری</td>
                <td>تا 1 فروردین</td>
            </tr>
            <tr>
                <td>هماهنگی با سخنرانان</td>
                <td>تا 31 فروردین</td>
            </tr>
            <tr>
                <td>هماهنگی با حامیان</td>
                <td>تا 31 فروردین</td>
            </tr>
            <tr>
                <td>برگزاری رویداد</td>
                <td>1 خرداد</td>
            </tr>
            <tr>
                <td>گزارش رویداد</td>
                <td>15 خرداد</td>
            </tr>
        </tbody>
    </table>
</p>

                                </div>
                              
                            </GridItem>
                        </GridContainer>
                        <GridContainer className={classes.box}>
                            <GridItem xs={12} sm={12} md={12}>
                                <h3>خلاصه</h3>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.description}>
                                <p>
                                ما گروهی از متخصصان موفق و تاثیرگذار دنیای فناوری اطلاعات را گرد هم می‌آوریم _کسانی که حرف‌های ارزشمندی برای گفتن دارند_ آن‌ها از آینده فناوری اطلاعات، تجربه‌هایی که چراغ راه فردا هستند و افق پیش روی فناوری در ایران سخن خواهند گفت.
                                </p>
                                    </div>
                                </GridItem>
                        </GridContainer>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
